let complete_pill_filters = {
          Focused: {name: 'Focused', display: 'Focused', is_active: 0, is_visible: true, count: 0},
          All: {name: 'All', display: 'All', is_active: 1, is_visible: true, count: 0},
          Completed: {name: 'Completed', display: 'Completed', is_active: 0, is_visible: true, count: 0},
          Unassigned: {name: 'Unassigned', display: 'Unassigned', is_active: 0, is_visible: true, count: 0}
}

module.exports = complete_pill_filters